/* eslint-disable consistent-return*/
import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';
import { setCookie } from 'helper/cookie';
// import { parseJWT } from 'helper/jwt';
import Swal from 'sweetalert2';
import Color from 'constants/color';

export const checkServerStatus = async (): Promise<'active' | 'off' | 'unknown' | 'error'> => {
  // try {
  //   const res = await fetch('https://do-power-on-worker.babybank40.workers.dev', {
  //     // const res = await fetch('http://127.0.0.1:8787', {
  //     method: 'POST',
  //   });

  //   if (!res.ok) {
  //     console.error(`❌ Server responded with status ${res.status}`);
  //     return 'error';
  //   }

  //   const data = await res.json();
  //   // console.log('data', data);
  //   const status = data?.status;

  //   if (status === 'active') {
  //     console.log('✅ Server is ON');
  //     return 'active';
  //   } else if (status === 'off') {
  //     console.warn('🛑 Server is OFF');
  //     return 'off';
  //   } else {
  //     console.log('⚠️ Unknown status:', status);
  //     return 'unknown';
  //   }
  // } catch (err) {
  //   console.error('❌ Failed to check server status:', err);
  //   return 'error';
  // }
  return 'active';
};

export const postLogin = async ({ params }: any) => {
  try {
    return await client
      .post(`login`, params, {})
      .then(response => {
        const data = get(response, 'data.data', '');
        const dataUser = data.dataUser;

        if (dataUser.status !== 'active') {
          Swal.fire({
            html: `
                     <h4 style="color: ${Color.danger}; padding: 10px;">ผู้ใช้ของคุณไม่สามารถเข้าใช้ระบบได้ กรุณาติดต่อ Admin</h4>
                  `,
            icon: 'error',
            confirmButtonText: 'ยืนยัน',
            showConfirmButton: false,
            showCancelButton: false,
            reverseButtons: true,
            showCloseButton: true,
            customClass: {
              confirmButton: '',
              cancelButton: 'swal2-cancel-none',
            },
            cancelButtonText: 'ยกเลิก',
          });
          return false;
        }
        if (dataUser.is_block === 'Y') {
          Swal.fire({
            html: `
                     <h4 style="color: ${Color.danger}; padding: 10px;">ผู้ใช้งานของคุณถูก บล็อค กรุณาติดต่อ Admin</h4>
                     <p class="text-danger">สาเหตุที่โดนบล็อค : ${dataUser.is_message_block} </p>
                  `,
            icon: 'error',
            confirmButtonText: 'ยืนยัน',
            showConfirmButton: false,
            showCancelButton: false,
            reverseButtons: true,
            showCloseButton: true,
            customClass: {
              confirmButton: '',
              cancelButton: 'swal2-cancel-none',
            },
            cancelButtonText: 'ยกเลิก',
          });
          return false;
        }
        if (dataUser.status === 'active' || dataUser.is_block === 'N') {
          // console.log('asdasd')
          setCookie('access_tokenltl', data.token);
          setCookie('refresh_tokenltl', data.refreshToken);
          setCookie('expires_tokenltl', data.expiresIn);
          setCookie('dataUser', JSON.stringify(dataUser));
          setCookie('credits_limit', dataUser?.credits_limit);
          setCookie('credits', dataUser?.credits);
          setCookie('point', dataUser?.point);
          setCookie('point_foreign', dataUser?.point_foreign);
          setCookie('point_stock', dataUser?.point_stock);
          get(response, 'data.data.token', '');
          setCookie('sessionId', data?.sessionId);
          Swal.fire({
            html: `
                        <h4 style="color: ${Color.greenDarken1}">เข้าสู่ระบบสำเร็จ</h4>
                    `,
            icon: 'success',
            confirmButtonText: 'ยอมรับ',
            showConfirmButton: true,
            showCancelButton: false,
            showCloseButton: true,
            reverseButtons: true,
            customClass: {
              confirmButton: '',
              cancelButton: 'swal2-cancel-none',
            },
            cancelButtonText: 'ยกเลิก',
          });
          return response;
        }
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postRefreshToken = async ({ params }: any) => {
  try {
    return await client
      .post(`refreshtoken`, params, {})
      .then(response => {
        const data = get(response, 'data.data', '');
        // const parsedJwt = parseJWT(data.token);
        const dataUser = data.dataUser;
        if (dataUser.status !== 'active') {
          Swal.fire({
            html: `
                     <h4 style="color: ${Color.danger}; padding: 10px;">ผู้ใช้ของคุณไม่สามารถเข้าใช้ระบบได้ กรุณาติดต่อ Admin</h4>
                  `,
            icon: 'error',
            confirmButtonText: 'ยืนยัน',
            showConfirmButton: false,
            showCancelButton: false,
            reverseButtons: true,
            showCloseButton: true,
            customClass: {
              confirmButton: '',
              cancelButton: 'swal2-cancel-none',
            },
            cancelButtonText: 'ยกเลิก',
          });
          return false;
        }
        if (dataUser.is_block === 'Y') {
          Swal.fire({
            html: `
                     <h4 style="color: ${Color.danger}; padding: 10px;">ผู้ใช้งานของคุณถูก บล็อค กรุณาติดต่อ Admin</h4>
                     <p class="text-danger">สาเหตุที่โดนบล็อค : ${dataUser.is_message_block} </p>
                  `,
            title: '',
            icon: 'error',
            confirmButtonText: 'ยืนยัน',
            showConfirmButton: false,
            showCancelButton: false,
            reverseButtons: true,
            showCloseButton: true,
            customClass: {
              confirmButton: '',
              cancelButton: 'swal2-cancel-none',
            },
            cancelButtonText: 'ยกเลิก',
          });
          return false;
        }
        if (dataUser.status === 'active' || dataUser.is_block === 'N') {
          setCookie('access_tokenltl', data.token);
          setCookie('refresh_tokenltl', data.refreshToken);
          setCookie('expires_tokenltl', data.expiresIn);
          setCookie('dataUser', JSON.stringify(dataUser));
          setCookie('credits_limit', dataUser?.credits_limit);
          setCookie('credits', dataUser?.credits);
          setCookie('point', dataUser?.point);
          setCookie('point_foreign', dataUser?.point_foreign);
          setCookie('point_stock', dataUser?.point_stock);
          setCookie('sessionId', data?.sessionId);
          get(response, 'data.data.token', '');
          return response;
        }
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};
